import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BusinessUserFilter, BusinessuserService } from 'src/app/services/businessuser.service';
import { EventService } from 'src/app/services/event.service';
import { EnvironmentService } from 'src/app/services/environment.service'
import { MatDialog } from '@angular/material/dialog';
import { ImageGalleryComponent } from '../../../../shared/image-gallery/image-gallery.component';
import { StockImagesGalleryComponent } from '../../../../shared/stock-images-gallery/stock-images-gallery.component';
import { AttachmentService } from 'src/app/services/attachment.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { AttachmentResource } from 'src/app/interfaces/attachment-resource';
import { Interest } from 'src/app/interfaces/interest';
import { EventResource } from 'src/app/interfaces/event-resource';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Clubstate } from 'src/app/interfaces/clubstate';
import { ClubstateService } from 'src/app/services/clubstate.service';
import { MatRadioChange } from '@angular/material/radio';
import { McpService } from 'src/app/services/mcp.service';
import { environment } from 'src/environments/environment';
import {
	DecoupledEditor,
	AccessibilityHelp,
	Alignment,
	AutoLink,
	Autosave,
	BalloonToolbar,
	BlockQuote,
	Bold,
	Essentials,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	GeneralHtmlSupport,
	Heading,
	Highlight,
	HorizontalLine,
	Indent,
	IndentBlock,
	Italic,
	Link,
  List,
	Paragraph,
	RemoveFormat,
	SelectAll,
	SpecialCharacters,
	Strikethrough,
	Underline,
	Undo,
	type EditorConfig,
  ClassicEditor
} from 'ckeditor5';

import translations from 'ckeditor5/translations/de.js';
import { Location } from '@angular/common';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
interface SortOption {
  value: string;
  viewValue: string;
}



@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})

export class EditComponent implements OnInit {
  /**
   * Does the mandant use PayPal
   */
  usesPayPal: boolean = false;

  private id;
  files: File[] = [];
  interests = []
  partners = []
  postMultimedias = [];
  clubstates: Array<Clubstate> = [];
  event: EventResource;
  addForm: UntypedFormGroup;
  addressForm: UntypedFormGroup;
  interestForm: UntypedFormGroup;
  priceForm: UntypedFormGroup;
  voucherCreationForm: UntypedFormGroup;
  limitationForm: UntypedFormGroup;
  dateForm: UntypedFormGroup;
  detailsForm: UntypedFormGroup;
  buttonConfigForm: UntypedFormGroup;
  type: string = "";
  currentEvent: EventResource;
  removedInterests = [];
  changeImage: boolean = false;
  finishedLoading: boolean = false;
  showClubState:boolean = false;

  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: [
        'undo',
        'redo',
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'fontColor',
        '|',
        'link',
        'alignment',
        '|',
        'bulletedList',
        'numberedList',
        'outdent',
        'indent'
      ],
      shouldNotGroupWhenFull: true
    },
    plugins: [
      AccessibilityHelp,
      Alignment,
      AutoLink,
      Autosave,
      BalloonToolbar,
      BlockQuote,
      Bold,
      Essentials,
      FontBackgroundColor,
      FontColor,
      FontFamily,
      FontSize,
      GeneralHtmlSupport,
      Heading,
      Highlight,
      HorizontalLine,
      Indent,
      IndentBlock,
      Italic,
      Link,
      Paragraph,
      RemoveFormat,
      SelectAll,
      SpecialCharacters,
      Strikethrough,
      Underline,
      Undo,
      List,
    ],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Überschrift 1',
          class: 'ck-heading_heading1'
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Überschrift 2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Überschrift 3',
          class: 'ck-heading_heading3'
        },   
        {
          model: 'heading4',
          view: 'h4',
          title: 'Überschrift 4',
          class: 'ck-heading_heading4'
        },           {
          model: 'heading5',
          view: 'h5',
          title: 'Überschrift 5',
          class: 'ck-heading_heading5'
        }, 
        {
          model: 'heading6',
          view: 'h6',
          title: 'Überschrift 6',
          class: 'ck-heading_heading6'
        },       
      ]
    },
    htmlSupport: {
      allow: [
        {
          name: /^.*$/,
          styles: true,
          attributes: true,
          classes: true
        }
      ]
    },
    language: 'de',
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file'
          }
        }
      }
    },
    placeholder: '',
    translations: [translations]
  }
  event_States = [
    { value: "CREATED", viewValue: "In Freigabe" },
    { value: "DRAFT", viewValue: "Entwurf" },
    { value: "PREVIEW", viewValue: "Vorschau" },
    { value: "ACTIVE", viewValue: "Aktiv" },
    { value: "HIDDEN", viewValue: "Versteckt" },
    { value: "CANCELLED", viewValue: "Storniert" },
    { value: "EXPIRED", viewValue: "Abgelaufen" },
    { value: "ARCHIVED", viewValue: "Archiviert" },
    { value: "DELETED", viewValue: "Gelöscht" }
  ]


  public dicountTypes = [
    { value: 'SERVICE_PLUS', viewValue: 'Exklusiv' },
    { value: 'MONETARY', viewValue: 'Preisvorteil' },
    { value: 'RAFFLE', viewValue: 'Gewinnspiel' },
    // { value: 'MONETARY', viewValue: 'Ticket (Bezahlpflichtige Aktion)', state: true },
    // { value: 'EXTERNAL_EVENT', viewValue: 'Externer Partner', state: true }
  ];

  public taxesRates = [
    { value: 'MWST_7', viewValue: 'Ermäßigte Mehrwertsteuer (7%)' },
    { value: 'MWST_19', viewValue: 'Mehrwertsteuer (19%)' }
  ]

  public voucherOptions = [
    { value: 'GATES', viewValue: 'Gates Gutscheincodes', state: false },
    { value: 'EXTERNAL_SINGLE_KEY', viewValue: 'Aktionspartnercodes (einer)', state: false },
    { value: 'EXTERNAL_KEY_LIST', viewValue: 'Aktionspartnercodes (mehrere)', state: false },
  ];

  public targetGroupOptions = [
    { value: 'WITHOUT_LIMIT', viewValue: 'Ohne Einschränkung', state: false },
    { value: 'ADULT', viewValue: 'Erwachsene (>= 18 Jahre)', state: false },
    { value: 'YOUTH', viewValue: 'unter 18-jährige', state: false },
    { value: 'CHILDREN', viewValue: 'Kinder (6-12 Jahre)', state: false },
    { value: 'CHILDREN2', viewValue: 'Kinder 2 (8-14 Jahre)', state: false },
    { value: 'WOMAN_ONLY', viewValue: 'Frauen (>=18 Jahre)', state: false },
    { value: 'MAN_ONLY', viewValue: 'Männer (>= 18 Jahre)', state: false },
    { value: 'TEENAGER', viewValue: 'Jugendliche (13-17 Jahre)', state: false },
    { value: 'BABYS', viewValue: 'Kleinkinder (0-5 Jahre)', state: false },
  ];

  public prioOptions = [
    { value: '0', viewValue: 'Standard', state: false },
    { value: '1000', viewValue: 'Top-Angebot 1', state: false },
    { value: '930', viewValue: 'Top-Angebot 2', state: false },
    { value: '920', viewValue: 'Top-Angebot 3', state: false },
    { value: '910', viewValue: 'Top-Angebot 4', state: false },
    { value: '900', viewValue: 'Top-Angebot 5', state: false },
    { value: '890', viewValue: 'Top-Angebot 6', state: false },
    { value: '880', viewValue: 'Top-Angebot 7', state: false },
    { value: '870', viewValue: 'Top-Angebot 8', state: false },
    { value: '860', viewValue: 'Top-Angebot 9', state: false },
    { value: '850', viewValue: 'Top-Angebot 10', state: false },
    { value: '840', viewValue: 'Top-Angebot 11', state: false },
    { value: '830', viewValue: 'Top-Angebot 12', state: false },
    { value: '820', viewValue: 'Top-Angebot 13', state: false },
    { value: '810', viewValue: 'Top-Angebot 14', state: false },
    { value: '800', viewValue: 'Top-Angebot 15', state: false },
    { value: '790', viewValue: 'Top-Angebot 16', state: false },
    { value: '780', viewValue: 'Top-Angebot 17', state: false },
    { value: '770', viewValue: 'Top-Angebot 18', state: false },
    { value: '760', viewValue: 'Top-Angebot 19', state: false },
    { value: '750', viewValue: 'Top-Angebot 20', state: false },
    { value: '740', viewValue: 'Top-Angebot 21', state: false },
    { value: '730', viewValue: 'Top-Angebot 22', state: false },
    { value: '720', viewValue: 'Top-Angebot 23', state: false },
    { value: '710', viewValue: 'Top-Angebot 24', state: false },
    { value: '700', viewValue: 'Top-Angebot 25', state: false },
    { value: '690', viewValue: 'Top-Angebot 26', state: false },
    { value: '680', viewValue: 'Top-Angebot 27', state: false },
    { value: '670', viewValue: 'Top-Angebot 28', state: false },
    { value: '660', viewValue: 'Top-Angebot 29', state: false },
    { value: '650', viewValue: 'Top-Angebot 30', state: false },
  ]


  imageProperties = [
    { key: 'logo', value: null, hint: 'Format: 800 x 500, Typ: .png', hasChanged: false },
  ];

  interestCheckboxOptions: Array<any> = []

  showAsHtml: boolean = false;

  constructor(
    private eventService: EventService,
    private fb: UntypedFormBuilder,
    private environmentService: EnvironmentService,
    private dialog: MatDialog,
    private attachmentService: AttachmentService,
    private overlayService: OverlayService,
    private router: Router,
    private route: ActivatedRoute,
    private clubstateService: ClubstateService,
    private mcp: McpService,
    private location:Location
  ) {
   

  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.type = params['type'];

      this.addForm = this.fb.group({
        image: ['', []],
        eventDiscount: ['', [Validators.required]],
        eventPartner: ['', [Validators.required]],
        title: ['', [Validators.required]],
        eventLimit: ['WITHOUT_LIMIT', [Validators.required]],
        state: ['CREATED', [Validators.required]],
        voucherKeyStrategy: ['GATES', [Validators.required]],
        description: ['', [Validators.required]],
        clientRef: [this.environmentService.getClientId(), [Validators.required]],
        savingInPercent: [null, []],
        regularPriceMoney: [null, []],
        eventPriceMoney: [null, []],
        taxRate: [null, []],
        autoStatus: [false, []],
        accessCode: [null, []],
        paymentRequired: [null, []],
        cancelable: [true, []],
      })
  
      this.addressForm = this.fb.group({
        street: ['', []],
        postcode: ['', []],
        city: ['', []],
      })
  
  
      this.interestForm = this.fb.group({
        interests: this.fb.array([])
      })
  
      this.priceForm = this.fb.group({
        type: ['1', []],
      })
  
      this.dateForm = this.fb.group({
        startDate: ['', [Validators.required]],
        endDate: ['', [Validators.required]],
        startTime: ['', []],
        endTime: ['', []],
      });
  
      this.buttonConfigForm = this.fb.group({
        buttonCaption: ['', []],
        buttonExternalLink: ['', []],
      })
  
      if (this.type == 'advanced') {
        this.voucherCreationForm = this.fb.group({
          voucherKeyStrategy: ['GATES', []],
          reservationValidTime: [0, []],
          validityDate: [, []],
          reservationClue: ['', []],
          sendReservationMail: [false, []],
          showReservationQR: [false, []],
          autoAttendance: [false, []],
          sendStornoMail: [false, []],
          validityPeriod: [false, []],
  
        })
  
        this.limitationForm = this.fb.group({
          perPersonQuota: ['0', []],
          reservationQuota: ['0', []],
          groupQuota: ['0', []],
        })
  
  
        this.detailsForm = this.fb.group({
          additionalInformationWebsite: ['', []],
          scheduleDescription: ['', []],
          location: ['', []],
          priority: [0, []],
          eventLimit: [, []],
        })
        
      }
      if (environment.clientID == 123) {
        this.addForm.addControl('customerValues', new FormControl([null, [Validators.required]]));
        this.showClubState = true;
      }
    })


    




    this.eventService.getInterests().subscribe((interests: any) => {
      this.interests = interests;
      this.interests.forEach(interest => {
        this.interestCheckboxOptions.push({ name: interest.name, value: interest.publicId, checked: false })
      });
    })

    this.clubstateService.getAllStates().subscribe({
      next: (states: Array<any>) => {
        this.clubstates = states;
      },
      error: err => {
        console.log(err)
      }
    })


    this.eventService.getPartners().subscribe((value:PagedResources<BusinessEntityResource>) => {
      this.partners = value.content
    })

    this.mcp.loadConfiguration().subscribe((config) => {
      this.usesPayPal = config?.usesPayPal;
    })




    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.currentEvent = params['id'];
      this.eventService.mergeOneEventFromV1andV2(this.id).subscribe((event: EventResource) => {
        this.event = event;
        if (event.customerValues && environment.clientID == 123) {
          event.customerValues = event.customerValues.replace(/[\[\]']+/g, '').split(',');
          this.addForm.controls.customerValues.patchValue(event.customerValues)
        }
        this.addForm.patchValue(event); 
        this.addForm.patchValue(event);
        this.addForm.patchValue(event);

        if (event.regularPriceMoney == null) {
          this.priceForm.patchValue({
            type: '2'
          });
        }

        this.addForm.patchValue({
          regularPriceMoney: event.regularPriceMoney?.amount,
          eventPriceMoney: event.eventPriceMoney?.amount,
          paymentRequired: event?.paymentRequired,
          taxRate: event?.taxRate
        });

        this.dateForm.patchValue({
          startDate: event?.start,
          endDate: event?.end,
          startTime: '',
          endTime: ''
        })

        if (this.type == 'advanced') {
          this.voucherCreationForm.patchValue({
            voucherKeyStrategy: event.voucherKeyStrategy,
            reservationValidTime: event.reservationValidTime,
            validityDate: event?.validityDate,
            reservationClue: event.reservationClue,
            sendReservationMail: event.sendReservationMail,
            showReservationQR: event?.showReservationQR,
            autoAttendance: event.autoAttendance,
            sendStornoMail: event.sendStornoMail,
            validityPeriod: String(event?.validityPeriod),

          })

          this.addressForm.patchValue({
            street: event?.address?.street,
            postcode: event?.address?.postcode,
            city: event?.address?.city
          })

          this.limitationForm.patchValue({
            perPersonQuota: event.perPersonQuota,
            reservationQuota: event.reservationQuota,
            groupQuota: event.groupQuota
          });

          this.buttonConfigForm.patchValue({
            buttonCaption: event.buttonCaption,
            buttonExternalLink: event.buttonExternalLink,
          })


          this.buttonConfigForm.patchValue({
            buttonCaption: event.buttonCaption,
            buttonExternalLink: event.buttonExternalLink,
          })


          this.detailsForm.patchValue({
            additionalInformationWebsite: event.additionalInformationWebsite,
            scheduleDescription: event.scheduleDescription,
            //Deprecated GSD-98
            //  location: event.location,
            priority: event.priority,
            eventLimit: event.eventLimit,
          })

          this.detailsForm.controls['location'].disable();

        }

        event.interests.forEach(element => {
          let i: number = 0;
          this.interestCheckboxOptions.forEach(checkboxOptions => {
            if (element.publicId == checkboxOptions.value) {
              this.interestCheckboxOptions[i].checked = true;
            }
            i++
          });

          let t = {
            checked: true,
            source: {
              value: {
                name: element.name,
                value: element.publicId
              }
            }
          }
          this.onCheckboxChange(t);

        });

        if (this.hasReservations()) {
          this.addForm.controls['eventDiscount'].disable();
          this.addForm.controls['savingInPercent'].disable();
          this.addForm.controls['regularPriceMoney'].disable();
          this.addForm.controls['eventPriceMoney'].disable();
          this.addForm.controls['paymentRequired'].disable();
          this.addForm.controls['taxRate'].disable();
          this.priceForm.disable();
        }
        this.finishedLoading = true;
      },
        error => {
          console.log("error: ", error);
          this.overlayService.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück")
        })
    });
  }

  get getaddFormControls() {
    return this.addForm.controls;
  }
  get getLimitationForm() {
    return this.limitationForm.controls
  }

  get getVoucherCreationForm() {
    return this.voucherCreationForm.controls
  }

  changeVoucherTime(event: MatRadioChange) {
    if (event.value == 'true') {
      this.voucherCreationForm.controls['validityDate'].reset();
      this.voucherCreationForm.controls['reservationValidTime'].addValidators([Validators.required]);
      this.voucherCreationForm.controls['reservationValidTime'].updateValueAndValidity();
      this.voucherCreationForm.controls['validityDate'].removeValidators([Validators.required]);
      this.voucherCreationForm.controls['validityDate'].updateValueAndValidity();

    } else {
      this.voucherCreationForm.controls['reservationValidTime'].reset()
      this.voucherCreationForm.controls['validityDate'].addValidators([Validators.required]);
      this.voucherCreationForm.controls['validityDate'].updateValueAndValidity();
      this.voucherCreationForm.controls['reservationValidTime'].removeValidators([Validators.required]);
      this.voucherCreationForm.controls['reservationValidTime'].updateValueAndValidity();
    }
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
    if (this.files.length != 0) {
      this.attachmentService.createAttachment(this.environmentService.getClientId(), this.files[0]).subscribe(attachment => {
        this.addForm.patchValue({
          image: attachment
        })
        this.changeImage = false;
      })
    }

  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  editEvent() {
    this.addForm.markAllAsTouched();
    this.addressForm.markAllAsTouched();
    this.interestForm.markAllAsTouched();

    if (this.type == 'advanced') {
      this.dateForm.markAllAsTouched();
      this.detailsForm.markAllAsTouched();
      this.voucherCreationForm.markAllAsTouched();
      this.limitationForm.markAllAsTouched();
      this.buttonConfigForm.markAllAsTouched();
    }

    if (this.addForm.value.eventDiscount == "MONETARY") {
      this.addForm.controls.savingInPercent.addValidators([Validators.required, Validators.max(100), Validators.min(0)]);
      this.addForm.controls.regularPriceMoney.addValidators([Validators.required]);
      this.addForm.controls.eventPriceMoney.addValidators([Validators.required]);
    }

    if (this.type == 'advanced') {
      this.voucherCreationForm.markAllAsTouched();
      this.limitationForm.markAllAsTouched();
    }

    if (this.type == 'advanced') {
      if (this.addForm.invalid || this.interestForm.invalid || this.dateForm.invalid || this.detailsForm.invalid || this.voucherCreationForm.invalid || this.limitationForm.invalid || this.addressForm.invalid) {
        return
      }
    } else {
      if (this.addForm.invalid || this.interestForm.invalid || this.addressForm.invalid) {
        return
      }
    }

    if (this.type == 'advanced') {
      //Convert Startdate to unix Time
      let startDate: Date = this.dateForm.value.startDate;
      //startDate.setHours(this.dateForm.value.startTime.split(':')[0])
      //startDate.setMinutes(this.dateForm.value.startTime.split(':')[1])
      //Convert EndDate to unix Time
      let endDate: Date = this.dateForm.value.endDate;
      //endDate.setHours(this.dateForm.value.endTime.split(':')[0])
      //endDate.setMinutes(this.dateForm.value.endTime.split(':')[1])

      //Overwrite resource from init with the data from the form
      let tempEvent: EventResource = this.event;
      tempEvent.address = {
        street: "",
        city: "",
        postcode: ""
      }
      tempEvent.image = this.addForm.value.image;
      tempEvent.state = this.addForm.value.state;
      tempEvent.eventDiscount = this.addForm.value.eventDiscount;
      tempEvent.eventPartner = this.addForm.value.eventPartner;
      tempEvent.title = this.addForm.value.title;
      tempEvent.eventLimit = this.addForm.value.eventLimit;
      tempEvent.state = this.addForm.value.state;
      tempEvent.accessCode = this.addForm.value?.accessCode

      tempEvent.voucherKeyStrategy = this.addForm.value.voucherKeyStrategy;

      tempEvent.description = String(this.addForm.getRawValue().description);
      tempEvent.clientRef = this.environmentService.getClientId();
      tempEvent.autoStatus = this.addForm.value.autoStatus;
      if (environment.clientID == 123) {
        tempEvent.customerValues = "[" + String(this.addForm.value.customerValues) + "]";
      }
      //Voucherlimitation
      tempEvent.voucherKeyStrategy = this.voucherCreationForm.value.voucherKeyStrategy;
      tempEvent.reservationClue = this.voucherCreationForm.value.reservationClue;
      tempEvent.sendReservationMail = this.voucherCreationForm.value.sendReservationMail;
      tempEvent.reservationValidTime = this.voucherCreationForm.value.reservationValidTime;

      tempEvent.validityDate = this.voucherCreationForm.value.validityDate;
      tempEvent.validityPeriod = this.voucherCreationForm.value.validityPeriod;
      tempEvent.autoAttendance = this.addForm.value.eventDiscount == "RAFFLE" ? false : this.voucherCreationForm.value.autoAttendance
      tempEvent.sendStornoMail = this.voucherCreationForm.value.sendStornoMail;
      tempEvent.showReservationQR = this.voucherCreationForm.value.showReservationQR;

      //limitation
      tempEvent.perPersonQuota = this.limitationForm.value.perPersonQuota;
      tempEvent.groupQuota = this.limitationForm.value.groupQuota;
      tempEvent.reservationQuota = this.limitationForm.value.reservationQuota;
      //DETAILS Limitation
      tempEvent.scheduleDescription = this.detailsForm.value.scheduleDescription;



      //Deprecated GSD-98
      //tempEvent.location = this.detailsForm.value.location;
      tempEvent.additionalInformationWebsite = this.detailsForm.value.additionalInformationWebsite;
      tempEvent.priority = this.detailsForm.value.priority;
      tempEvent.eventLimit = this.detailsForm.value.eventLimit;


      tempEvent.address.street = this.addressForm.value.street;
      tempEvent.address.city = this.addressForm.value.city;
      tempEvent.address.postcode = this.addressForm.value.postcode;



      tempEvent.paymentRequired = this.addForm?.getRawValue().paymentRequired;
      tempEvent.taxRate = this.addForm?.getRawValue().taxRate;

      tempEvent.reservationRequired = true;

      tempEvent.buttonCaption = this.buttonConfigForm.getRawValue().buttonCaption;
      tempEvent.buttonExternalLink = this.buttonConfigForm.getRawValue().buttonExternalLink;
      //Date Limitation
      if (this.dateForm.value.startDate != null && this.dateForm.value.endDate != null) {

        let startDate = new Date(this.dateForm.value.startDate);
        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(1)

        let endDate = new Date(this.dateForm.value.endDate);
        endDate.setHours(23)
        endDate.setMinutes(59)
        endDate.setSeconds(59)


        tempEvent.startDate = startDate.getTime();
        tempEvent.endDate =endDate.getTime();
        tempEvent.start = new Date(this.dateForm.value.startDate).toISOString().split('T')[0];
        tempEvent.end = new Date(this.dateForm.value.endDate).toISOString().split('T')[0]
      }


      if (this.addForm.value.eventDiscount != 'MONETARY') {

      } else {
        if (this.priceForm.value.type == '1') {
          tempEvent.regularPriceMoney = {
            "currency": "EUR",
            "amount": this.addForm.value.regularPriceMoney
          }
          tempEvent.eventPriceMoney = {
            "currency": "EUR",
            "amount": this.addForm.value.eventPriceMoney
          }
          tempEvent.savingInPercent = 100 - (this.addForm.value.eventPriceMoney / this.addForm.value.regularPriceMoney) * 100;
        } else if (this.priceForm.value.type == '2') {
          tempEvent.regularPriceMoney = null;
          tempEvent.eventPriceMoney = null;
          tempEvent.regularPrice = null;
          tempEvent.eventPrice = null;
          tempEvent.savingInPercent = this.addForm.value.savingInPercent;
        }
      }



      this.eventService.editEvent(tempEvent).subscribe({
        next: (returnFromEdit: EventResource) => {
          if (returnFromEdit) {
            this.interestForm.value.interests.forEach(interestToAdd => {
              if (interestToAdd?.checked != null) {
                let tempInteres: Interest = {
                  'name': interestToAdd.name,
                  'publicId': interestToAdd.value
                }
                this.eventService.addInterestToEvent(this.event.publicId, tempInteres).subscribe(value => {
                })
              }
            });

            this.removedInterests.forEach(interestToRemove => {
              this.eventService.removeInterestFromEvent(this.event.publicId, interestToRemove.value).subscribe(value => {
              })
            });
            this.overlayService.openSnackBar("Aktion erfolgreich geändert!");
            //  this.movebacktoOverview();
          }
        },
        error: err => {
          console.log(err)
        }
      })
    } else {
      let tempEvent: EventResource = this.event;
      tempEvent.address = {
        street: "",
        city: "",
        postcode: ""
      }


      tempEvent.image = this.addForm.value.image;
      tempEvent.eventDiscount = this.addForm.value.eventDiscount;
      tempEvent.eventPartner = this.addForm.value.eventPartner;
      tempEvent.title = this.addForm.value.title;
      tempEvent.eventLimit = this.addForm.value.eventLimit;
      tempEvent.state = this.addForm.value.state;
      tempEvent.description = String(this.addForm.getRawValue().description);
      tempEvent.clientRef = this.environmentService.getClientId();
      tempEvent.voucherKeyStrategy = this.addForm.value.voucherKeyStrategy;
      tempEvent.autoStatus = this.addForm.value.autoStatus;
      if (environment.clientID == 123) {
        tempEvent.customerValues = "[" + String(this.addForm.value.customerValues) + "]";
      }
      tempEvent.accessCode = this.addForm.value?.accessCode;
      tempEvent.address.street = this.addressForm.value.street;
      tempEvent.address.city = this.addressForm.value.city;
      tempEvent.address.postcode = this.addressForm.value.postcode;

      if (this.addForm.value.eventDiscount != 'MONETARY') {

      } else {
        if (this.priceForm.value.type == '1') {
          tempEvent.regularPriceMoney = {
            "currency": "EUR",
            "amount": this.addForm.value.regularPriceMoney
          }
          tempEvent.eventPriceMoney = {
            "currency": "EUR",
            "amount": this.addForm.value.eventPriceMoney
          }
          tempEvent.savingInPercent = 100 - (this.addForm.value.eventPriceMoney / this.addForm.value.regularPriceMoney) * 100;
        } else if (this.priceForm.value.type == '2') {
          tempEvent.regularPriceMoney = null;
          tempEvent.eventPriceMoney = null;
          tempEvent.regularPrice = null;
          tempEvent.eventPrice = null;
          tempEvent.savingInPercent = this.addForm.value.savingInPercent;
        }
      }
      this.eventService.editEvent(tempEvent).subscribe((returnFromEdit: EventResource) => {
        this.event = returnFromEdit;
        if (returnFromEdit) {
          this.interestForm.value.interests.forEach(interestToAdd => {
            if (interestToAdd?.checked != null) {
              let tempInteres: Interest = {
                'name': interestToAdd.name,
                'publicId': interestToAdd.value
              }
              this.eventService.addInterestToEvent(this.event.publicId, tempInteres).subscribe(value => {
              })
            }
          });

          this.removedInterests.forEach(interestToRemove => {
            this.eventService.removeInterestFromEvent(this.event.publicId, interestToRemove.value).subscribe(value => {
            })
          });
          this.overlayService.openSnackBar("Aktion erfolgreich geändert!");
          //    this.movebacktoOverview();
        }
      })
    }
  }

  openImageGallery(property) {
    const dialogRef = this.dialog.open(ImageGalleryComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.addForm.patchValue({
          image: result
        })
        this.event.image = result;
        property.value = result.url;
        property.hasChanged = true;
        property.newValue = `${result.clientRef}/attachment/${result.publicId}`;
      }
    });
  }

  openStockImageGallery() {
    const dialogRef = this.dialog.open(StockImagesGalleryComponent, {
      minWidth: '25vw',
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        const image = await fetch(result.largeImageURL)
        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)

        const link = document.createElement('a')
        link.href = imageURL
        link.download = `${result.id}.jpeg`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link);
        this.changeImage = true;
      }
    });
  }

  onCheckboxChange(e) {
    const checkArray: UntypedFormArray = this.interestForm.get('interests') as UntypedFormArray;
    if (e.checked) {
      checkArray.push(new UntypedFormControl(e.source.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value.value == e.source.value.value) {
          this.removedInterests.push(item.value)
          checkArray.removeAt(i);
          return;
        }
        i++;
      });

    }
  }

  jumpToAddress() {
    document.getElementById('address')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }


  movebacktoOverview() {
  //  this.router.navigateByUrl('caseworker/event')
  this.location.back();
  }

  moveToExpertView() {
    this.router.navigateByUrl('caseworker/event/overview/add/advanced')
  }

  setPartnerForSelect(o1, o2): boolean {
    return o1.name === o2.name;
  }

  setTypeForSelect(o1, o2): boolean {
    return o1 === o2;
  }

  setPrioForSelect(o1, o2): boolean {
    return String(o1) === String(o2);

  }

  editPartnerCodes() {
    this.overlayService.openVoucherCodesEdit("Externe Gutschein-Codes", "Aktuelle Gutschein-Codes", "Speichern", this.event.publicId)
  }

  showUsedPartnerCodes() {
    this.overlayService.openUsedVoucherCodes("Externe Gutschein-Codes", "Genutzte Gutschein-Codes", "Schließen", this.event.publicId)
  }

  uploadAttachment() {
    this.attachmentService.createAttachment(this.environmentService.getClientId(), this.files[0]).subscribe(attachment => {
      this.addForm.patchValue({
        image: attachment
      })
    })
  }

  toogleImageUpload() {
    this.changeImage = !this.changeImage;
  }


  changeDiscountType() {
    if (this.priceForm.getRawValue().type == '1') {
      this.addForm.controls.savingInPercent.removeValidators(Validators.required);
      this.addForm.controls.regularPriceMoney.addValidators(Validators.required);
      this.addForm.controls.eventPriceMoney.addValidators(Validators.required);

      this.addForm.controls.savingInPercent.setValue("");

      this.addForm.controls.savingInPercent.updateValueAndValidity();
      this.addForm.controls.regularPriceMoney.updateValueAndValidity();
      this.addForm.controls.eventPriceMoney.updateValueAndValidity();


    } else if (this.priceForm.getRawValue().type == '2') {
      this.addForm.controls.savingInPercent.addValidators(Validators.required);
      this.addForm.controls.regularPriceMoney.removeValidators(Validators.required);
      this.addForm.controls.eventPriceMoney.removeValidators(Validators.required);

      this.addForm.controls.regularPriceMoney.setValue("");
      this.addForm.controls.eventPriceMoney.setValue("");

      this.addForm.controls.savingInPercent.updateValueAndValidity();
      this.addForm.controls.regularPriceMoney.updateValueAndValidity();
      this.addForm.controls.eventPriceMoney.updateValueAndValidity();
    }
  }


  hasReservations() {
    var hasReservations = this.addForm.getRawValue().eventDiscount == 'MONETARY' && this.event.totalActiveReservationsCount > 0;
    return hasReservations;
  }

  showEventStateModal() {
    this.overlayService.openAutoEventStatusInfoComponent("Hinweis", "", "Schließen", "Abbrechen").subscribe({
      next: res => {
        console.log(res)
      }, error: err => {
        console.error(err)
      }
    })
  }
}


